import React, { useMemo } from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Divider from '@material-ui/core/Divider';
import ListItemText from '@material-ui/core/ListItemText';
import styled from 'styled-components';
import Logo from '../../../Logo';
import makeStyles from '@material-ui/core/styles/makeStyles';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ReceiptIcon from '@material-ui/icons/Receipt';
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';

const SidebarContent = styled.div`
  color: #ffffff;
  padding: 0px 20px;
`;

const ContentSection = styled.div`
  color: #ffffff;
  padding: 20px 0px;
`;

const FlavorLabel = styled.div`
  box-shadow: 0 4px 20px 0 rgb(0 0 0 / 14%), 0 7px 10px -5px rgb(149 83 0 / 40%);
  background: linear-gradient(60deg, #ffae48, #fb8c00);
  margin-top: 5px;
  width: 70%;
  padding: 3px;
  border-radius: 3px;
`;

const useStyles = makeStyles((theme) => ({
  divider: {
    background: '#ffffff',
  },
}));


const Content = () => {
  const classes = useStyles();
  const { name, role } = useSelector((state) => state.login.data);
  const flavourLabel = process.env.REACT_APP_FLAVOR_LABEL || null;

  const links = useMemo(() => {
    switch (role){
      case 'accountant':
        return [
          {
            label: 'Dashboard',
            link: '/',
            icon: ReceiptIcon,
          },
          {
            label: 'Statistiky',
            link: '/stats',
            icon: ReceiptIcon,
          },
        ];

      default:
        return [
          {
            label: 'Pos',
            link: '/pos',
            icon: ReceiptIcon,
          },
        ];
    }
  }, [role]);

  return (
    <SidebarContent>
      <ContentSection style={{ textAlign: 'center', alignItems: 'center', display: 'flex', flexDirection: 'column' }}>
        <Logo fill='#ffffff' width={'100px'} />
        {flavourLabel && <FlavorLabel>{flavourLabel}</FlavorLabel>}
      </ContentSection>
      <Divider classes={{ root: classes.divider }} />

      <ContentSection style={{ display: 'flex', justifyContent: 'center' }}>
        <div style={{ display: 'flex' }}>
          <AccountCircleIcon />
          <div style={{ paddingLeft: '10px' }}>{name}</div>
        </div>
      </ContentSection>
      <Divider classes={{ root: classes.divider }} />

      <List>
        {links.map((link, index) => (
          <ListItem button key={index} component={NavLink} to={link.link}>
            <ListItemIcon>
              <link.icon style={{ color: '#ffffff' }} />
            </ListItemIcon>
            <ListItemText primary={link.label} />
          </ListItem>
        ))}
      </List>
    </SidebarContent>
  );
};

export default Content;
